// Mutations change the store. Never mutate the store outside a mutation.
// All mutations must be triggered by a commit in a  action.
import '../../utilities/ie11polyfill.js'
import { nanoid } from 'nanoid'

export default {
	
	//ACCOMMODATION
	//----------------------------------------------------------

	SET_ACCOMMODATION(state, payload) {
		state.accommodation = payload
	},

	SET_SEARCHFILTERS(state, payload) {
		//state.filters = payload
		state.accommodation.apiFilters = payload
	},

	SET_CABIN_AREAS(state, payload) {
		state.cabinAreas = payload
	},

	SET_FILTERS(state, payload) {
		//state.filters = payload
		state.accommodation.apiFilters = payload
	},

	SET_DATES_AND_PEOPLE(state, payload) {
		//state.datesAndPeople = payload
		state.accommodation.datesAndPeople = payload
	},

	SET_ACCOMMODATION_RANDOM_LIST_ORDER(state, payload) {
		state.accommodation.accRandomListOrder = payload
	},

	//Spara boendet man kollar när man går in på det efter filtering
	SET_ACCOMMODATIONS_LIST(state, payload) {
		//state.filteredAccommodations = payload
		state.accommodation.list = [...payload]
	},

	SET_AREAS_RANDOM_LIST_ORDER(state, payload) {
		state.accommodation.areasRandomListOrder = payload
	},

	PUT_ACCOMMODATION_IN_CART(state, payload) {
		const newList = [...state.cart.accommodation, payload]
		state.cart.accommodation = newList
		
		// matomoTracker.addToCart(payload.id, payload.title, payload.type, payload.price, 1);
	},

	DELETE_ACCOMMODATION_FROM_CART(state, payload) {
		const newList = state.cart.accommodation.filter(each => {
			return !(each.poollid == payload.poollid &&
			each.unitlid == payload.unitlid &&
			each.arrdate == payload.arrdate
				? payload.arrdate
				: payload.startDate && each.depdate == payload.depdate
				? payload.depdate
				: payload.endDate)
		})
		state.cart.accommodation = newList
	},

	CHANGE_ACCOMMODATION_IN_CART(state, payload) {
		const newList = state.cart.accommodation.map(each => {
			if (
				each.poollid == payload.accommodation.poollid &&
				each.unitlid == payload.accommodation.unitlid
			) {
				each.noofchild2 = payload.people.noofchild2
				each.noofchild3 = payload.people.noofchild3
				each.noofchild5 = payload.people.noofchild5
				each.price = payload.price
				each.ordinaryprice = payload.ordinaryprice
			}
			return each
		})
		state.cart.accommodation = newList
	},

	EMPTY_CART(state) {
		state.cart = {
			customerlid: null,
			allowcancellation: true,
			allowmodification: true,
			resvid: '',
			currency: 'SEK',
			accommodation: [],
			skipass: [],
			skischool: [],
			skirental: [],
			activities: [],
			deliveryPrice: null,
			delivery: false,
			delivertoaccommodation: null,
			delivertoother: null,
			keycardPrice: null,
			cartCheckoutClicked: false,
			everytingIsValid: true,
			fastCheckout: true,
			accordion: {
				showAccommodation: false,
				showSkipass: false,
				showSkischool: false,
				showSkirental: false,
				showActivities: false
			}
		}
	},

	SET_CHECKOUT(state, payload) {
		state.checkout = payload
	},

	SET_CART_TOTAL_PRICE(state, payload) {
		state.cartTotalPrice = payload
	},

	UPDATE_CART_DELIVERY(state, payload) {
		state.cart.delivery = payload.delivery
		state.cart.delivertoaccommodation = payload.delivertoaccommodation
		state.cart.delivertoother = payload.delivertoother
	},

	//Spara bekräftelse id:et som sedan visas på tacksidan
	SET_CONFROMATION_ID(state, payload) {
		state.confirmationId = payload
	},

	DELETE_CART_ITEM(state, payload) {
		const cartItems = Object.values(state.cart.accommodation)
		let filteredCartItems = cartItems.filter(function (item) {
			if (
				item['poollid'] != payload.poollid &&
				item['unitlid'] != payload.unitlid
			) {
				return item
			}
		})
		state.cart.accommodation = filteredCartItems
	},

	SET_CART_ADDONS(state, payload) {
		const updatedCart = state.cart.accommodation.map(obj => {
			if (
				obj.objectId == payload.objectId ||
				(obj.detlid && obj.detlid == payload.productDetlid)
			) {
				return { ...obj, addons: payload.addons }
			} else {
				return obj
			}
		})

		state.cart.accommodation = updatedCart
	},

	//SKIPASS

	SET_CART_SKIPASS(state, payload) {
		const list = []

		// split amunt of skipass into singel skipasses
		for (let i = 0; i < payload.length; i++) {
			const each = payload[i]

			for (let index = 0; index < each.value; index++) {
				let newItem = Object.assign({}, each)

				// Deactivate fast checkout if product is not valid for that
				if (newItem.connected == false || newItem.photoMandatory == true) {
					state.cart.fastCheckout = false
				}

				// Set a new ID
				newItem.uniqueId = nanoid()
				newItem.type = 'skipass'
				newItem.endDate = newItem.endDate ? newItem.endDate : newItem.startDate
				newItem.qty = 1
				;(newItem.allowcancellation = true),
					(newItem.allowmodify = true),
					(newItem.guestValidation = {
						keycard: true,
						age: true,
						length: true,
						weight: true,
						shoesize: true,
						guest: true,
						phone: true
					})
				list.push(newItem)

				//matomoTracker.addToCart(newItem.id, newItem.name, newItem.type, newItem.price, newItem.qty)
			}
		}

		state.cart.skipass.push(...list)
		state.cart.keycardPrice = payload[0].keycardPrice
	},

	DELETE_CART_SKIPASS(state, payload) {
		const updatedCart = state.cart.skipass.filter(function (item) {
			if (item.uniqueId != payload.uniqueId) {
				return item
			}
		})
		state.cart.skipass = updatedCart
	},

	SET_CART_SKIPASS_KEYCARD(state, payload) {
		const updatedCart = state.cart.skipass.map(obj =>
			obj.uniqueId == payload.uniqueId
				? { ...obj, keynumber: payload.value }
				: obj
		)
		state.cart.skipass = updatedCart
	},

	PUT_CART_SKIPASS_GUEST(state, payload) {
		state.cart.skipass = state.cart.skipass.map(each => {
			if (
				each.uniqueId == payload.skipass.uniqueId &&
				each.startDate == payload.skipass.startDate
			) {
				each.addrlid = parseInt(payload.guestlid)
				each.guestlid = parseInt(payload.guestlid)
			}
			return each
		})
	},
	VALIDATE_PRODUCTS_IN_CART(state, payload) {
		// Payload = {type: 'type of cart', product: product, guestValidation: validations, everytingIsValid: bool}

		state.cart[payload.type] = state.cart[payload.type].map(each => {
			if (
				each.uniqueId == payload.product.uniqueId &&
				each.startDate == payload.product.startDate
			) {
				each.guestValidation = payload.guestValidation
			}
			return each
		})
		state.cart.everytingIsValid = payload.everytingIsValid
	},

	//SKIRENTAL

	SET_CART_SKIRENTAL(state, payload) {
		const list = []
		//Takes all skirentals and add them as a unique product
		for (let i = 0; i < payload.length; i++) {
			const each = payload[i]
			//assignes a new unique id for each product
			for (let index = 0; index < each.value; index++) {
				let newItem = Object.assign({}, each)
				// Set a new ID
				newItem.uniqueId = nanoid()
				newItem.type = 'skirental'
				newItem.qty = 1
				;(newItem.allowcancellation = true),
					(newItem.allowmodify = true),
					(newItem.guestValidation = {
						keycard: true,
						age: true,
						length: true,
						weight: true,
						shoesize: true,
						guest: true,
						phone: true
					})
				list.push(newItem)

				//matomoTracker.addToCart(newItem.id, newItem.name, newItem.type, newItem.price, newItem.qty)
			}
		}

		state.cart.skirental.push(...list)

		// Set deliveryPrice
		let deliveryPrice = -1
		const priceArray = state.cart.skirental
			.filter(each => each.deliveryPrice >= 0)
			.map(each => each.deliveryPrice)
		if (priceArray.length) {
			deliveryPrice = Math.min(...priceArray)
		}
		state.cart.deliveryPrice = deliveryPrice
	},

	SET_CART_SKIRENTAL_INSURANCE(state, payload) {
		const updatedCart = state.cart.skirental.map(obj =>
			obj.uniqueId == payload.uniqueId
				? { ...obj, insurance: payload.value }
				: obj
		)
		state.cart.skirental = updatedCart
	},

	SET_CART_SKIRENTAL_COMMENT(state, payload) {
		const updatedCart = state.cart.skirental.map(obj =>
			obj.uniqueId == payload.uniqueId
				? { ...obj, comment: payload.value }
				: obj
		)
		state.cart.skirental = updatedCart
	},

	DELETE_CART_SKIRENTAL(state, payload) {
		const updatedCart = state.cart.skirental.filter(function (item) {
			deliveryPrice =
				item.deliveryPrice > deliveryPrice ? item.deliveryPrice : deliveryPrice

			if (item.uniqueId != payload.uniqueId) {
				return item
			}
		})

		state.cart.skirental = updatedCart

		// Set deliveryPrice
		let deliveryPrice = -1
		const priceArray = state.cart.skirental
			.filter(each => each.deliveryPrice >= 0)
			.map(each => each.deliveryPrice)
		if (priceArray.length) {
			deliveryPrice = Math.min(...priceArray)
		}

		if (deliveryPrice == -1) {
			state.cart.delivery = false
			state.cart.delivertoaccommodation = null
			state.cart.delivertoother = null
		}

		state.cart.deliveryPrice = deliveryPrice
	},

	PUT_CART_SKIRENTAL_GUEST(state, payload) {
		state.cart.skirental = state.cart.skirental.map(each => {
			if (
				each.uniqueId == payload.skirental.uniqueId &&
				each.startDate == payload.skirental.startDate
			) {
				each.addrlid = parseInt(payload.guestlid)
				each.guestlid = parseInt(payload.guestlid)
			}
			return each
		})
	},

	//SKISCHOOL

	SET_CART_SKISCHOOL(state, payload) {
		const list = []
		//Takes all skirentals and add them as a unique product
		for (let i = 0; i < payload.length; i++) {
			const each = payload[i]
			//assignes a new unique id for each product
			for (let index = 0; index < each.value; index++) {
				let newItem = Object.assign({}, each)
				// Set a new ID
				newItem.uniqueId = nanoid()
				newItem.type = 'skischool'
				newItem.qty = 1
				;(newItem.allowcancellation = true),
					(newItem.allowmodify = true),
					(newItem.guestValidation = {
						keycard: true,
						age: true,
						length: true,
						weight: true,
						shoesize: true,
						guest: true,
						phone: true
					})
				list.push(newItem)

				//matomoTracker.addToCart(newItem.id, newItem.name, newItem.type, newItem.price, newItem.qty)
			}
		}
		state.cart.skischool.push(...list)
	},

	SET_CART_SKISCHOOL_COMMENT(state, payload) {
		const updatedCart = state.cart.skischool.map(obj =>
			obj.uniqueId == payload.uniqueId
				? { ...obj, comment: payload.value }
				: obj
		)
		state.cart.skischool = updatedCart
	},

	DELETE_CART_SKISCHOOL(state, payload) {
		const updatedCart = state.cart.skischool.filter(function (item) {
			if (item.uniqueId != payload.uniqueId) {
				return item
			}
		})
		state.cart.skischool = updatedCart
	},

	PUT_CART_SKISCHOOL_GUEST(state, payload) {
		state.cart.skischool = state.cart.skischool.map(each => {
			if (
				each.uniqueId == payload.skischool.uniqueId &&
				each.startDate == payload.skischool.startDate
			) {
				each.addrlid = parseInt(payload.guestlid)
				each.guestlid = parseInt(payload.guestlid)
			}
			return each
		})
	},

	//ACTIVITIES

	SET_CART_ACTIVITIES(state, payload) {
		const list = []
		//Takes all activities and add them as a unique product
		for (let i = 0; i < payload.length; i++) {
			const each = payload[i]
			//assignes a new unique id for each product
			for (let index = 0; index < each.value; index++) {
				let newItem = Object.assign({}, each)
				// Set a new ID
				newItem.uniqueId = nanoid()
				newItem.type = 'activities'
				newItem.qty = 1
				;(newItem.allowcancellation = true),
					(newItem.allowmodify = true),
					(newItem.guestValidation = {
						keycard: true,
						age: true,
						length: true,
						weight: true,
						shoesize: true,
						guest: true,
						phone: true
					})
				list.push(newItem)

				//matomoTracker.addToCart(newItem.id, newItem.name, newItem.type, newItem.price, newItem.qty)
			}
		}
		state.cart.activities.push(...list)
	},

	SET_CART_ACTIVITIES_COMMENT(state, payload) {
		const updatedCart = state.cart.activities.map(obj =>
			obj.uniqueId == payload.uniqueId
				? { ...obj, comment: payload.value }
				: obj
		)
		state.cart.activities = updatedCart
	},

	DELETE_CART_ACTIVITIES(state, payload) {
		const updatedCart = state.cart.activities.filter(function (item) {
			if (item.uniqueId != payload.uniqueId) {
				return item
			}
		})
		state.cart.activities = updatedCart
	},

	PUT_CART_ACTIVITIES_GUEST(state, payload) {
		state.cart.activities = state.cart.activities.map(each => {
			if (
				each.uniqueId == payload.activities.uniqueId &&
				each.startDate == payload.activities.startDate
			) {
				each.addrlid = parseInt(payload.guestlid)
				each.guestlid = parseInt(payload.guestlid)
			}
			return each
		})
	},

	ADD_BOOKING_TO_CART(state, payload) {
		payload.accommodation.forEach(each => {
			if (each.addons.length) {
				for (let i = 0; i < each.addons.length; i++) {
					each.addons[i].qty_original = each.addons[i].qty
				}
			}

			each.currency = each.currency ? each.currency : payload.currency
			each.original_noofchild2 = each.noofchild2
			each.original_noofchild3 = each.noofchild3
			each.original_noofchild5 = each.noofchild5
		})

		payload.skipass.forEach(each => {
			each.uniqueId = each.detlid
			each.type = 'skipass'
			each.guestValidation = {
				keycard: true,
				age: true,
				length: true,
				weight: true,
				shoesize: true,
				guest: true,
				phone: true
			}
		})

		payload.skirental.forEach(each => {
			each.addrlid = each.guestlid
			each.uniqueId = each.detlid
			each.type = 'skirental'
			each.guestValidation = {
				keycard: true,
				age: true,
				length: true,
				weight: true,
				shoesize: true,
				guest: true,
				phone: true
			}
			each.insurance_original = each.insurance
			each.name = each.desc1

			if (each.pricewithinsurance && each.pricewithoutinsurance) {
				each.price =
					each.price !== each.pricewithoutinsurance
						? each.pricewithoutinsurance
						: each.price
			}
			each.priceWithInsurance = each.pricewithinsurance
				? each.pricewithinsurance
				: each.price
		})

		payload.skischool.forEach(each => {
			each.addrlid = each.guestlid
			each.uniqueId = each.detlid
			each.type = 'skischool'
			each.endTime = each.activitydays[0].totime
			each.startTime = each.activitydays[0].fromtime
			each.guestValidation = {
				keycard: true,
				age: true,
				length: true,
				weight: true,
				shoesize: true,
				guest: true,
				phone: true
			}
		})

		payload.activities.forEach(each => {
			each.addrlid = each.guestlid
			each.uniqueId = each.detlid
			each.type = 'activities'
			each.endTime = each.activitydays[0].totime
			each.startTime = each.activitydays[0].fromtime
			each.guestValidation = {
				keycard: true,
				age: true,
				length: true,
				weight: true,
				shoesize: true,
				guest: true,
				phone: true
			}
		})

		payload.delivery_original = payload.delivery

		state.cart = { ...state.cart, ...payload }
	},

	//XX
	//----------------------------------------------------------

	SET_WEATHER(state, payload) {
		state.weather = payload
	},

	SET_USER(state, payload) {
		state.user = payload
	},

	SET_GUEST(state, payload) {
		if (state.user.guests == null) {
			state.user.guests = []
		}
		const newQuestList = [...state.user.guests]
		const matchIndex = newQuestList.findIndex(
			each => each.guestlid == payload.guestlid
		)

		if (matchIndex >= 0) {
			newQuestList[matchIndex] = payload
		} else {
			newQuestList.push(payload)
		}

		state.user.guests = newQuestList
	},

	REMOVE_GUEST(state, payload) {
		const removeGuest = state.user.guests.filter(function (guest) {
			if (guest.guestlid != payload) {
				return guest
			}
		})

		state.user.guests = removeGuest
	},

	SET_CAMPAIGN_CODE(state, payload) {
		state.campaignCode = payload
	},

	SET_API_RESP_STATUS(state, payload) {
		state.apiResponseStatus = payload
	},

	//Sätter token när man loggar in
	SET_TOKEN(state, payload) {
		state.token = payload
	},

	SET_PRODUCT_SELECTED_FILTERS(state, payload) {
		state.productList.selectedFilters = payload
	},

	SET_PRODUCT_SELECTED_FILTER_TYPE(state, payload) {
		state.productList.selectedFilterType = payload
	},

	REMOVE_PRODUCT_SELECTED_ITEM(state, item) {
		const newList = [...state.productList.selectedItems]

		let findIndex = newList.findIndex(each => {
			return each.id == item.id && each.date == item.date
		})

		newList.splice(findIndex, 1)

		state.productList.selectedItems = newList
	},
	REMOVE_ALL_PRODUCT_SELECTED_ITEMS(state) {
		state.productList.selectedItems = []
	},

	SET_PRODUCT_SELECTED_ITEMS(state, item) {
		const newList = [...state.productList.selectedItems]

		let findIndex = newList.findIndex(each => {
			return each.id == item.id && each.startDate == item.startDate
		})

		if (findIndex != -1) {
			if (item.value > 0) {
				newList[findIndex] = item
			} else {
				newList.splice(findIndex, 1)
			}
		} else if (item.value > 0) {
			newList.push(item)
		}

		state.productList.selectedItems = newList
	},

	CLEAR_PRODUCT_FILTERS_AND_ITEMS(state) {
		state.productList = {
			selectedFilterType: null,
			selectedFilters: [],
			selectedItems: []
		}
	},

	TOGGLE_GLOBAL_MODAL(state, type) {
		state.globalModals = { ...state.globalModals, ...type }
	},

	TOGGLE_CART_ACCORDION(state, type) {
		state.cart.accordion = { ...state.cart.accordion, ...type }
	},

	CART_CHECKOUT_CLICK(state, payload) {
		state.cart.cartCheckoutClicked = payload
	},

	CART_COMPLETE_CANCELLATION(state, payload) {
		state.cart.completeCancellation = payload
	},

	SET_FAST_CHECKOUT(state, payload) {
		state.cart.fastCheckout = payload
	}
}
